<template>
  <div class="prescription">
    <el-form ref="prescription_form" :model="list2form" label-position="left" label-width="70px" :show-message="false" :hide-required-asterisk="true">
      <div v-for="(item, index) in list" :key="item.recipeId" class="item">
        <!-- 非处方项目 -->
        <template v-if="item.recipeType === 0">
          <div class="header">
            <div class="header_left">
              <span
                :class="{
                  'el-icon-success': true,
                  'header_left_icon': true,
                  'icon_success': formulaStatus(item).status
                }">
              </span>
              <div class="header_left_title">非处方项目</div>
              <div class="header_left_tips">数量{{ drugsCount(item.prescriptionPaymentVOS,item.recipeType).drugSum }}，包含{{ drugsCount(item.prescriptionPaymentVOS,item.recipeType).typeSum }}个品种</div>
              <el-popover
                placement="top"
                popper-class="formula_popover"
                trigger="hover">
                <div v-if="formulaStatus(item).type === 2" class="header_error_row">
                  <div v-for="drug in formulaStatus(item).list" :key="drug.spuId" class="header_error_item">
                    <div class="header_error_item_left">
                      <span class="header_error_item_left_name">{{ drug.spuCommonName }}</span>
                      <span class="header_error_item_left_num">{{ drug.useDrugNum }}{{ drug.unit }}</span>
                    </div>
                    <div class="header_error_item_right">{{ drug.text }}</div>
                  </div>
                </div>
                <div v-else class="header_error_lineText">{{ formulaStatus(item).text }}</div>
                <span slot="reference" v-show="!formulaStatus(item).status" class="el-icon-warning header_left_error">药品内容未通过</span>
              </el-popover>
            </div>
            <div class="header_right" v-if="!chargeFlag">
              <el-button type="text" class="header_right_btn" @click="addFormula(item)">新增配方单</el-button>
            </div>
          </div>
          <div v-for="(formula, formulaIndex) in item.prescriptionPaymentVOS" :key="formula.virtuallyId" :class="{ formula: true, formula_disabled: !formula.formulaEdit }">
            <span v-show="formula.payStatus === 3" class="iconfont icon-yituif formula_refund"></span>
            <div class="formula_header">
              <div class="formula_header_left">
                <div class="formula_header_title">配方单{{ formulaIndex + 1 }}</div>
                <div v-show="formula.status !== 0" class="formula_header_status" :style="`background-color: ${formulaStage(formula).bgColor};`">{{ formulaStage(formula).name }}</div>
                <div v-show="formula.drugWayId === '-1'" class="formula_header_tips">该配方单将暂不会发送，请确认后及时处理！</div>
              </div>
              <div class="formula_header_right">
                <el-button v-show="formula.status !== 0 && !formula.formulaEdit && formula.payStatus !== 3" class="formula_header_btn" @click="toFormulaEdit(formula)">修改</el-button>
                <el-popover
                  popper-class="formula_popover sf-popover"
                  placement="right-start"
                  width="230"
                  trigger="click">
                  <div class="formula_log" style="padding: 12px;box-sizing: border-box">
                    <div v-for="(log, logIndex) in formula.operateLogs" :key="logIndex" class="formula_log_item">
                      <div class="formula_log_title">{{ log.actionName }}（{{ log.deptName }}）</div>
                      <div v-if="log.operateData && log.operateData.resources && log.operateData.resources.length>0" class="list_item_right_text">
                        <el-image 
                          v-for="(item1, index) in log.operateData.resources"
                          :key="index"
                          style="width: 40px; height: 40px;margin: 6px"
                          :src="item1.resUrl" 
                          :preview-src-list="log.operateData.resources.map(item2 => item2.resUrl)"
                        ></el-image>
                      </div>
                      <div class="formula_log_text">操作员：{{ log.createBy }}</div>
                      <div class="formula_log_text">操作时间：{{ log.createTime }}</div>
                      <div v-if="log.remark" class="formula_log_text">
                        <span class="formula_log_text_label">{{ log.action === 5 ? '拒绝原因' : '修改说明' }}：</span>
                        <span class="formula_log_text_value">{{ log.remark }}</span>
                      </div>
                    </div>
                  </div>
                  <el-button slot="reference" v-show="formula.status !== 0" class="formula_header_btn">操作日志</el-button>
                </el-popover>
                <!-- <el-checkbox v-show="formula.status === 0" class="formula_header_right_freight" v-model="formula.deliveryFree" :true-label="1" :false-label="0" border>免运费</el-checkbox> -->
                <el-popconfirm
                  class="custom_popconfirm"
                  title="是否确定删除该配方单？"
                  @confirm="deleteFormula(item.prescriptionPaymentVOS, formula.virtuallyId)">
                  <el-button slot="reference" v-if="formula.status === 0 && formula.payStatus === 0 && item.prescriptionPaymentVOS.length > 1" class="formula_header_right_delete" type="text" icon="el-icon-delete"></el-button>
                </el-popconfirm>
                <el-popover
                  popper-class="formula_popover sf-popover"
                  placement="right-start"
                  width="270"
                  trigger="click"
                  @show="formula.showPopover = true"
                  @hide="formula.showPopover = copyInfo.showToolTip = false"
                >
                  <div class="transport-detail">
                    <div class="transport-detail-title">
                      <span>{{ transportInfo.logisticContext.companyName || '' }}：{{ formula.trackingNumber }}</span>
                      <el-tooltip placement="top" manual :value='copyInfo.showToolTip'>
                        <div slot="content">复制成功</div>
                        <i class="icon el-icon-copy-document" :class="{ active: copyInfo.showToolTip }" @click="copyTransportNumHandle(formula.trackingNumber)"></i>
                      </el-tooltip>
                    </div>
                    <div v-if="transportInfo.transportStepInfoList.length > 0"  class="transport-detail-content">
                      <div
                        class="transport-detail-content-item"
                        v-for="(item, index) in transportInfo.transportStepInfoList"
                        :key="index"
                      >
                        <div class="transport-detail-content-item-title">{{ item.acceptStation || '' }}</div>
                        <div class="transport-detail-content-item-time">{{ item.acceptTime || '' }}</div>
                      </div>
                    </div>
                    <div v-else class="transport-detail-content mt10 ml10">
                      暂未查询到相关物流信息
                    </div>
                  </div>
                  <el-button
                    slot="reference"
                    v-show="!!formula.trackingNumber"
                    class="formula_header_btn" 
                    @click="getTransportDetail(formula.showPopover, formula.id, formula.trackingNumber)"
                  >查看物流</el-button>
                </el-popover>
              </div>
            </div>
            <div class="formula_info">
              <el-form-item class="formula_info_item_mini" label="药品内容">
                <div class="formula_info_row">
                  <el-form-item :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugs`" :rules="checkOtherDrugsSelect(formula.drugs)">
                    <el-popover
                      placement="bottom"
                      popper-class="formula_popover"
                      trigger="click">
                      <div class="formula_drugs">
                        <div class="drugs_header">
                          <div class="drugs_header_title">选择药品</div>
                          <el-checkbox :indeterminate="drugIsIndeterminate(formula.drugs)" v-model="formula.checkAll" @change="drugsCheckAll(formula)" :disabled="!(formula.formulaEdit&&formula.drugEdit) || chargeFlag">全选</el-checkbox>
                        </div>
                        <div class="drugs_list_other">
                          <div v-for="(drug, drugIndex) in formula.drugs" :key="drug.spuId" class="drugs_list_other_item">
                            <el-checkbox class="drugs_list_other_checkbox" v-model="drug.checkStatus" :true-label="1" :false-label="0" @change="drugsCheck(formula, drug, `list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugs[${drugIndex}].useDrugNum`)" :disabled="!(formula.formulaEdit&&formula.drugEdit) || chargeFlag">{{ drug.spuCommonName }}</el-checkbox>
                            <div class="drugs_other_info">
                              <span class="el-icon-close drugs_other_info_icon"></span>
                              <el-form-item :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugs[${drugIndex}].useDrugNum`" :rules="checkOtherDrugsNum(drug)">
                                <el-input class="formula_input" v-model.trim="drug.useDrugNum" style="width: 70px;" oninput="if(isNaN(value)) { value = null } if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+3) } else if ( value.indexOf('.') === 0 ) { value = null }" @blur="drugNumBlur(drug)" :disabled="!(formula.formulaEdit&&formula.drugEdit) || chargeFlag">
                                  <span slot="suffix">{{ drug.unit }}</span>
                                </el-input>
                              </el-form-item>
                              <span class="drugs_other_info_text">共{{drug.drugNum }}{{ drug.unit }}</span>
                              <span v-show="drug.drugNumRefund > 0" class="drugs_other_info_return">已退{{ drug.drugNumRefund }}{{ drug.unit }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-input slot="reference" class="formula_input formula_input_2left" style="width: 96px;" :value="otherDrugsCheckCount(formula.drugs)" readonly>
                        <span slot="prefix">已选</span>
                      </el-input>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-form-item>
              <div class="formula_info_footer">
                <div class="formula_info_footer_item">
                  <el-form-item label="取药方式" :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugWayId`" :rules="rules.drugWayId">
                    <el-select class="formula_input_border" v-model="formula.drugWayId" placeholder="请选择处理方式" clearable :disabled="!(formula.formulaEdit&&formula.drugWayEdit)">
                      <el-option
                        v-for="(takeWay, takeWayIndex) in takeWayList"
                        :key="takeWay.drugWayId"
                        :label="`取药方式${takeWayIndex + 1}`"
                        :value="takeWay.drugWayId"
                        :disabled="takeWay.handlingTime < today">
                      </el-option>
                      <el-option label="暂不处理" value="-1" :disabled="chargeFlag && formula.status !== 0"></el-option>
                      <el-option label="无需处理" value="-2" :disabled="chargeFlag"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="formula_info_footer_item formula_info_remark">
                  <el-form-item label="备注">
                    <el-input class="formula_input_border" v-model="formula.remark" placeholder="请输入备注" :disabled="!(formula.formulaEdit&&formula.remarkEdit)"></el-input>
                  </el-form-item>
                </div>
                <div v-if="!['', '-1', '-2'].includes(formula.drugWayId)" class="formula_info_takeWay">时间：{{computedDrugWay(formula.drugWayId).handlingTime}}，医馆：{{computedDrugWay(formula.drugWayId).transferDeptName}}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 中成药处方 -->
        <template v-if="item.recipeType === 4">
          <div class="header">
            <div class="header_left">
              <span
                :class="{
                  'el-icon-success': true,
                  'header_left_icon': true,
                  'icon_success': formulaStatus(item).status
                }">
              </span>
              <div class="header_left_title">中成药处方{{ item.orderNum }}</div>
              <div class="header_left_tips">数量{{ drugsCount(item.prescriptionPaymentVOS,item.recipeType).drugSum }}，包含{{ drugsCount(item.prescriptionPaymentVOS,item.recipeType).typeSum }}个品种</div>
              <el-popover
                placement="top"
                popper-class="formula_popover"
                trigger="hover">
                <div v-if="formulaStatus(item).type === 2" class="header_error_row">
                  <div v-for="drug in formulaStatus(item).list" :key="drug.spuId" class="header_error_item">
                    <div class="header_error_item_left">
                      <span class="header_error_item_left_name">{{ drug.spuCommonName }}</span>
                      <span class="header_error_item_left_num">{{ drug.useDrugNum }}{{ drug.unit }}</span>
                    </div>
                    <div class="header_error_item_right">{{ drug.text }}</div>
                  </div>
                </div>
                <div v-else class="header_error_lineText">{{ formulaStatus(item).text }}</div>
                <span slot="reference" v-show="!formulaStatus(item).status" class="el-icon-warning header_left_error">药品内容未通过</span>
              </el-popover>
            </div>
            <div class="header_right" v-if="!chargeFlag">
              <el-button type="text" class="header_right_btn" @click="addFormula(item)">新增配方单</el-button>
            </div>
          </div>
          <div v-for="(formula, formulaIndex) in item.prescriptionPaymentVOS" :key="formula.virtuallyId" :class="{ formula: true, formula_disabled: !formula.formulaEdit }">
            <span v-show="formula.payStatus === 3" class="iconfont icon-yituif formula_refund"></span>
            <div class="formula_header">
              <div class="formula_header_left">
                <div class="formula_header_title">配方单{{ formulaIndex + 1}}</div>
                <div v-show="formula.status !== 0" class="formula_header_status" :style="`background-color: ${formulaStage(formula).bgColor};`">{{ formulaStage(formula).name }}</div>
                <div v-show="formula.drugWayId === '-1'" class="formula_header_tips">该配方单将暂不会发送，请确认后及时处理！</div>
              </div>
              <div class="formula_header_right">
                <el-button v-show="formula.status !== 0 && !formula.formulaEdit && formula.payStatus !== 3" class="formula_header_btn" @click="toFormulaEdit(formula)">修改</el-button>
                <el-popover
                  popper-class="formula_popover sf-popover"
                  placement="right-start"
                  width="230"
                  trigger="click">
                  <div class="formula_log" style="padding: 12px;box-sizing: border-box">
                    <div v-for="(log, logIndex) in formula.operateLogs" :key="logIndex" class="formula_log_item">
                      <div class="formula_log_title">{{ log.actionName }}（{{ log.deptName }}）</div>
                      <div v-if="log.operateData && log.operateData.resources && log.operateData.resources.length>0" class="list_item_right_text">
                        <el-image 
                          v-for="(item1, index) in log.operateData.resources"
                          :key="index"
                          style="width: 40px; height: 40px;margin: 6px"
                          :src="item1.resUrl" 
                          :preview-src-list="log.operateData.resources.map(item2 => item2.resUrl)"
                        ></el-image>
                      </div>
                      <div class="formula_log_text">操作员：{{ log.createBy }}</div>
                      <div class="formula_log_text">操作时间：{{ log.createTime }}</div>
                      <div v-if="log.remark" class="formula_log_text">
                        <span class="formula_log_text_label">{{ log.action === 5 ? '拒绝原因' : '修改说明' }}：</span>
                        <span class="formula_log_text_value">{{ log.remark }}</span>
                      </div>
                    </div>
                  </div>
                  <el-button slot="reference" v-show="formula.status !== 0" class="formula_header_btn">操作日志</el-button>
                </el-popover>
                <!-- <el-checkbox v-show="formula.status === 0" class="formula_header_right_freight" v-model="formula.deliveryFree" :true-label="1" :false-label="0" border>免运费</el-checkbox> -->
                <el-popconfirm
                  class="custom_popconfirm"
                  title="是否确定删除该配方单？"
                  @confirm="deleteFormula(item.prescriptionPaymentVOS, formula.virtuallyId)">
                  <el-button slot="reference" v-if="formula.status === 0 && formula.payStatus === 0 && item.prescriptionPaymentVOS.length > 1" class="formula_header_right_delete" type="text" icon="el-icon-delete"></el-button>
                </el-popconfirm>
                <el-popover
                  popper-class="formula_popover sf-popover"
                  placement="right-start"
                  width="270"
                  trigger="click"
                  @show="formula.showPopover = true"
                  @hide="formula.showPopover = copyInfo.showToolTip = false"
                >
                  <div class="transport-detail">
                    <div class="transport-detail-title">
                      <span>{{ transportInfo.logisticContext.companyName || '' }}：{{ formula.trackingNumber }}</span>
                      <el-tooltip placement="top" manual :value='copyInfo.showToolTip'>
                        <div slot="content">复制成功</div>
                        <i class="icon el-icon-copy-document" :class="{ active: copyInfo.showToolTip }" @click="copyTransportNumHandle(formula.trackingNumber)"></i>
                      </el-tooltip>
                    </div>
                    <div v-if="transportInfo.transportStepInfoList.length > 0"  class="transport-detail-content">
                      <div
                        class="transport-detail-content-item"
                        v-for="(item, index) in transportInfo.transportStepInfoList"
                        :key="index"
                      >
                        <div class="transport-detail-content-item-title">{{ item.acceptStation || '' }}</div>
                        <div class="transport-detail-content-item-time">{{ item.acceptTime || '' }}</div>
                      </div>
                    </div>
                    <div v-else class="transport-detail-content mt10 ml10">
                      暂未查询到相关物流信息
                    </div>
                  </div>
                  <el-button
                    slot="reference"
                    v-show="!!formula.trackingNumber"
                    class="formula_header_btn" 
                    @click="getTransportDetail(formula.showPopover, formula.id, formula.trackingNumber)"
                  >查看物流</el-button>
                </el-popover>
              </div>
            </div>
            <div class="formula_info">
              <el-form-item class="formula_info_item_mini" label="药品内容">
                <div class="formula_info_row">
                  <el-form-item :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugs`" :rules="checkOtherDrugsSelect(formula.drugs)">
                    <el-popover
                      placement="bottom"
                      popper-class="formula_popover"
                      trigger="click">
                      <div class="formula_drugs">
                        <div class="drugs_header">
                          <div class="drugs_header_title">选择药品</div>
                          <el-checkbox :indeterminate="drugIsIndeterminate(formula.drugs)" v-model="formula.checkAll" @change="drugsCheckAll(formula)" :disabled="!(formula.formulaEdit&&formula.drugEdit) || chargeFlag">全选</el-checkbox>
                        </div>
                        <div class="drugs_list_other">
                          <div v-for="(drug, drugIndex) in formula.drugs" :key="drug.spuId" class="drugs_list_other_item">
                            <el-checkbox class="drugs_list_other_checkbox" v-model="drug.checkStatus" :true-label="1" :false-label="0" @change="drugsCheck(formula, drug, `list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugs[${drugIndex}].useDrugNum`)" :disabled="!(formula.formulaEdit&&formula.drugEdit) || chargeFlag">{{ drug.spuCommonName }}</el-checkbox>
                            <div class="drugs_other_info">
                              <span class="el-icon-close drugs_other_info_icon"></span>
                              <el-form-item :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugs[${drugIndex}].useDrugNum`" :rules="checkOtherDrugsNum(drug)">
                                <el-input class="formula_input" v-model.trim="drug.useDrugNum" style="width: 70px;" oninput="if(isNaN(value)) { value = null } if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+3) } else if ( value.indexOf('.') === 0 ) { value = null }" @blur="drugNumBlur(drug)" :disabled="!(formula.formulaEdit&&formula.drugEdit) || chargeFlag">
                                  <span slot="suffix">{{ drug.unit }}</span>
                                </el-input>
                              </el-form-item>
                              <span class="drugs_other_info_text">共{{ drug.drugNum }}{{ drug.unit }}</span>
                              <span v-show="drug.drugNumRefund > 0" class="drugs_other_info_return">已退{{ drug.drugNumRefund }}{{ drug.unit }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-input slot="reference" class="formula_input formula_input_2left" style="width: 96px;" :value="otherDrugsCheckCount(formula.drugs)" readonly>
                        <span slot="prefix">已选</span>
                      </el-input>
                    </el-popover>
                  </el-form-item>
                </div>
              </el-form-item>
              <div class="formula_info_footer">
                <div class="formula_info_footer_item">
                  <el-form-item label="取药方式" :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugWayId`" :rules="rules.drugWayId">
                    <el-select class="formula_input_border" v-model="formula.drugWayId" placeholder="请选择处理方式" clearable :disabled="!(formula.formulaEdit&&formula.drugWayEdit)">
                      <el-option
                        v-for="(takeWay, takeWayIndex) in takeWayList"
                        :key="takeWay.drugWayId"
                        :label="`取药方式${takeWayIndex + 1}`"
                        :value="takeWay.drugWayId"
                        :disabled="takeWay.handlingTime < today">
                      </el-option>
                      <el-option label="暂不处理" value="-1" :disabled="chargeFlag && formula.status !== 0"></el-option>
                      <el-option label="无需处理" value="-2" :disabled="chargeFlag"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="formula_info_footer_item formula_info_remark">
                  <el-form-item label="备注">
                    <el-input class="formula_input_border" v-model="formula.remark" placeholder="请输入备注" :disabled="!(formula.formulaEdit&&formula.remarkEdit)"></el-input>
                  </el-form-item>
                </div>
                <div v-if="!['', '-1', '-2'].includes(formula.drugWayId)" class="formula_info_takeWay">时间：{{computedDrugWay(formula.drugWayId).handlingTime}}，医馆：{{computedDrugWay(formula.drugWayId).transferDeptName}}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 中药处方 -->
        <template v-if="item.recipeType === 1">
          <div class="header">
            <div class="header_left">
              <span
                :class="{
                  'el-icon-success': true,
                  'header_left_icon': true,
                  'icon_success': formulaStatus(item).status
                }">
              </span>
              <div class="header_left_title">中药处方{{ item.orderNum }}</div>
              <div class="header_left_tips">共{{ item.recipeDO.realDoseNum || item.recipeDO.doseNum }}剂，单剂{{ item.prescriptionPaymentVOS[0].drugs.length }}味</div>
              <el-popover
                placement="top"
                popper-class="formula_popover"
                trigger="hover">
                <div v-if="formulaStatus(item).type === 2" class="header_error_row">
                  <div v-for="drug in formulaStatus(item).list" :key="drug.spuId" class="header_error_item">
                    <div class="header_error_item_left">
                      <span class="header_error_item_left_name">{{ drug.spuCommonName }}</span>
                      <span class="header_error_item_left_num">{{ drug.doseNum }}剂 * {{ drug.useDrugNum }}{{ drug.unit }}</span>
                    </div>
                    <div class="header_error_item_right">{{ drug.text }}</div>
                  </div>
                </div>
                <div v-else class="header_error_lineText">{{ formulaStatus(item).text }}</div>
                <span slot="reference" v-show="!formulaStatus(item).status" class="el-icon-warning header_left_error">药品内容未通过</span>
              </el-popover>
            </div>
            <div class="header_right" v-if="!chargeFlag">
              <el-button type="text" class="header_right_btn" @click="addFormula(item)">新增配方单</el-button>
            </div>
          </div>
          <div v-for="(formula, formulaIndex) in item.prescriptionPaymentVOS" :key="formula.virtuallyId" :class="{ formula: true, formula_disabled: !formula.formulaEdit }">
            <span v-show="formula.payStatus === 3" class="iconfont icon-yituif formula_refund"></span>
            <div class="formula_header">
              <div class="formula_header_left">
                <div class="formula_header_title">配方单{{ formulaIndex + 1}}</div>
                <div v-show="formula.status !== 0" class="formula_header_status" :style="`background-color: ${formulaStage(formula).bgColor};`">{{ formulaStage(formula).name }}</div>
                <div v-show="formula.drugWayId === '-1'" class="formula_header_tips">该配方单将暂不会发送，请确认后及时处理！</div>
              </div>
              <div class="formula_header_right">
                <el-button v-show="formula.status !== 0 && !formula.formulaEdit && formula.payStatus !== 3" class="formula_header_btn" @click="toFormulaEdit(formula)">修改</el-button>
                <el-popover
                  popper-class="formula_popover sf-popover"
                  placement="right-start"
                  width="230"
                  trigger="click">
                  <div class="formula_log" style="padding: 12px;box-sizing: border-box">
                    <div v-for="(log, logIndex) in formula.operateLogs" :key="logIndex" class="formula_log_item">
                      <div class="formula_log_title">{{ log.actionName }}（{{ log.deptName }}）</div>
                      <div v-if="log.operateData && log.operateData.resources && log.operateData.resources.length>0" class="list_item_right_text">
                        <el-image 
                          v-for="(item1, index) in log.operateData.resources"
                          :key="index"
                          style="width: 40px; height: 40px;margin: 6px"
                          :src="item1.resUrl" 
                          :preview-src-list="log.operateData.resources.map(item2 => item2.resUrl)"
                        ></el-image>
                      </div>
                      <div class="formula_log_text">操作员：{{ log.createBy }}</div>
                      <div class="formula_log_text">操作时间：{{ log.createTime }}</div>
                      <div v-if="log.remark" class="formula_log_text">
                        <span class="formula_log_text_label">{{ log.action === 5 ? '拒绝原因' : '修改说明' }}：</span>
                        <span class="formula_log_text_value">{{ log.remark }}</span>
                      </div>
                    </div>
                  </div>
                  <el-button slot="reference" v-show="formula.status !== 0" class="formula_header_btn">操作日志</el-button>
                </el-popover>
                <!-- <el-checkbox v-show="formula.status === 0" class="formula_header_right_freight" v-model="formula.deliveryFree" :true-label="1" :false-label="0" border>免运费</el-checkbox> -->
                <el-popconfirm
                  class="custom_popconfirm"
                  title="是否确定删除该配方单？"
                  @confirm="deleteFormula(item.prescriptionPaymentVOS, formula.virtuallyId)">
                  <el-button slot="reference" v-if="formula.status === 0 && formula.payStatus === 0 && item.prescriptionPaymentVOS.length > 1" class="formula_header_right_delete" type="text" icon="el-icon-delete"></el-button>
                </el-popconfirm>
                <el-popover
                  popper-class="formula_popover sf-popover"
                  placement="right-start"
                  width="270"
                  trigger="click"
                  @show="formula.showPopover = true"
                  @hide="formula.showPopover = copyInfo.showToolTip = false"
                >
                  <div class="transport-detail">
                    <div class="transport-detail-title">
                      <span>{{ transportInfo.logisticContext.companyName || '' }}：{{ formula.trackingNumber }}</span>
                      <el-tooltip placement="top" manual :value='copyInfo.showToolTip'>
                        <div slot="content">复制成功</div>
                        <i class="icon el-icon-copy-document" :class="{ active: copyInfo.showToolTip }" @click="copyTransportNumHandle(formula.trackingNumber)"></i>
                      </el-tooltip>
                    </div>
                    <div v-if="transportInfo.transportStepInfoList.length > 0"  class="transport-detail-content">
                      <div
                        class="transport-detail-content-item"
                        v-for="(item, index) in transportInfo.transportStepInfoList"
                        :key="index"
                      >
                        <div class="transport-detail-content-item-title">{{ item.acceptStation || '' }}</div>
                        <div class="transport-detail-content-item-time">{{ item.acceptTime || '' }}</div>
                      </div>
                    </div>
                    <div v-else class="transport-detail-content mt10 ml10">
                      暂未查询到相关物流信息
                    </div>
                  </div>
                  <el-button
                    slot="reference"
                    v-show="!!formula.trackingNumber"
                    class="formula_header_btn" 
                    @click="getTransportDetail(formula.showPopover, formula.id, formula.trackingNumber)"
                  >查看物流</el-button>
                </el-popover>
              </div>
            </div>
            <div class="formula_info">
              <el-form-item class="formula_info_item_mini" label="药品内容">
                <div class="formula_info_row">
                  <el-form-item :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].dosage`" :rules="checkNumber(formula.dosage)">
                    <el-input :ref="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].dosage`" class="formula_input" style="width: 80px;" v-model.trim="formula.dosage" oninput="if(isNaN(value)) { value = null } if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+0) } else if ( value.indexOf('.') === 0 ) { value = null }" @blur="dosageBlur(formula, `list[${index}].prescriptionPaymentVOS[${formulaIndex}]`)" :disabled="!(formula.formulaEdit&&formula.drugEdit) || chargeFlag">
                      <span slot="suffix">剂</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugs`" :rules="checkDrugsSelect(formula.drugs)">
                    <el-popover
                      placement="bottom"
                      width="430"
                      popper-class="formula_popover"
                      trigger="click">
                      <div class="formula_drugs">
                        <div class="drugs_header">
                          <div class="drugs_header_title">选择药品</div>
                          <el-checkbox :indeterminate="drugIsIndeterminate(formula.drugs)" v-model="formula.checkAll" @change="drugsCheckAll(formula)" :disabled="!(formula.formulaEdit&&formula.drugEdit) || chargeFlag">全选</el-checkbox>
                        </div>
                        <div class="drugs_list_default">
                          <el-checkbox v-for="drug in formula.drugs" :key="drug.spuId" class="drugs_list_default_item" v-model="drug.checkStatus" :true-label="1" :false-label="0" :disabled="drug.isOwned === 1 || !(formula.formulaEdit&&formula.drugEdit) || drug.status === 1 || chargeFlag" @change="drugsCheck(formula)">
                            <div class="drugs_list_default_item_label">{{ drug.spuCommonName }}{{ drug.isOwned === 1 ? '(自备)' : '' }}</div>
                            <div v-show="drug.status === 1" class="drugs_list_default_item_return">已退</div>
                          </el-checkbox>
                        </div>
                      </div>
                      <el-input slot="reference" class="formula_input formula_input_2left" style="width: 96px;" :value="drugsCheckCount(formula.drugs)" readonly>
                        <span slot="prefix">已选</span>
                        <span slot="suffix">味</span>
                      </el-input>
                    </el-popover>
                  </el-form-item>
                  <div v-show="formula.payStatus === 2 && formula.dosageRefund > 0" class="drugs_list_default_item_return">已退{{ formula.dosageRefund }}剂</div>
                </div>
              </el-form-item>
              <el-form-item class="formula_info_item_mini" label="加工方式">
                <div class="formula_info_row">
                  <el-form-item :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].handlingWay`" :rules="rules.handlingWay">
                    <el-cascader
                      class="formula_input formula_cascader"
                      style="width: 62px;"
                      v-model="formula.handlingWay"
                      :options="options"
                      :show-all-levels="false"
                      placeholder=""
                      :disabled="!(formula.formulaEdit&&formula.processEdit) || chargeFlag"
                      @change="handlingWayChange(formula, item.recipeDO)">
                    </el-cascader>
                  </el-form-item>
                  <el-form-item v-if="formula.handlingWay && formula.handlingWay[0] === '熬药'" :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].prescriptionNum`" :rules="checkNumber(formula.prescriptionNum)">
                    <el-input class="formula_input formula_input_2left" style="width: 96px;" v-model="formula.prescriptionNum" oninput="if(isNaN(value)) { value = null } if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+2) } else if ( value.indexOf('.') === 0 ) { value = null }" @blur="prescriptionNumBlur(formula, `list[${index}].prescriptionPaymentVOS[${formulaIndex}]`)" :disabled="!(formula.formulaEdit&&formula.processEdit)">
                      <span slot="prefix">每剂</span>
                      <span slot="suffix">袋</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-if="formula.handlingWay && formula.handlingWay[0] === '熬药'" :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].prescriptionTotalNum`" :rules="checkNumber(formula.prescriptionTotalNum)">
                    <el-input class="formula_input" style="width: 80px;" v-model="formula.prescriptionTotalNum" oninput="if(isNaN(value)) { value = null } if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+0) } else if ( value.indexOf('.') === 0 ) { value = null }" @blur="prescriptionTotalNumBlur(formula, `list[${index}].prescriptionPaymentVOS[${formulaIndex}]`)" :disabled="!(formula.formulaEdit&&formula.processEdit)">
                      <span slot="prefix">共</span>
                      <span slot="suffix">袋</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-if="formula.handlingWay && formula.handlingWay[0] === '熬药'" :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].prescriptionSpecsNum`" :rules="rules.prescriptionSpecsNum">
                    <SelectPanel
                      class="formula_input"
                      v-model="formula.prescriptionSpecsNum"
                      width="96px"
                      :columnsNum="3"
                      :options="takingDosageList.map(v => { return { label: v, value: v } })"
                      placeholder="服用剂量"
                      :disabled="!(formula.formulaEdit&&formula.processEdit)"
                      clearable>
                    </SelectPanel>
                  </el-form-item>
                  <el-form-item v-if="formula.handlingWay && formula.handlingWay[0] !== ''" :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].handlingAmount`" :rules="rules.handlingAmount">
                    <el-input class="formula_input formula_input_2left" style="width: 112px;" v-model="formula.handlingAmount" oninput="if(isNaN(value)) { value = null } if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+3) } else if ( value.indexOf('.') === 0 ) { value = null }" @blur="handlingAmountBlur(formula)" :disabled="!(formula.formulaEdit&&formula.processEdit) || chargeFlag">
                      <span slot="prefix">金额</span>
                      <span slot="suffix">元</span>
                    </el-input>
                  </el-form-item>
                  <div v-if="formula.processStatus === 1" class="process_refund">已退</div>
                </div>
                <div v-show="formula.handlingWay && formula.handlingWay[0]" class="formula_info_row">
                  <span class="prescription_usage">
                    <span v-if="item.recipeDO.recipeMethod">{{ item.recipeDO.recipeMethod }}</span>
                    <span v-if="item.recipeDO.doseFrequency">，{{ item.recipeDO.doseFrequency }}</span>
                    <span v-if="item.recipeDO.frequency">，{{ item.recipeDO.frequency }}</span>
                    <span v-if="item.recipeDO.takingDosage">，{{ item.recipeDO.takingDosage }}</span>
                    <span v-if="item.recipeDO.mixingBagNum">，每次{{ item.recipeDO.mixingBagNum }}袋</span>
                    <span v-if="item.recipeDO.creamDosage">，{{ item.recipeDO.creamDosage }}</span>
                    <span v-if="item.recipeDO.pelletizingDosage">，{{ item.recipeDO.pelletizingDosage }}</span>
                    <span v-if="item.recipeDO.bakingPowderDosage">，{{ item.recipeDO.bakingPowderDosage }}</span>
                    <span v-if="item.recipeDO.takingDays">，{{ item.recipeDO.takingDays }}</span>
                    <span v-if="item.recipeDO.recipeMoment">，{{ item.recipeDO.recipeMoment }}</span>
                    <span v-if="item.recipeDO.applicationTime">，{{ item.recipeDO.applicationTime }}</span>
                    <span v-if="item.recipeDO.wrapTime">，{{ item.recipeDO.wrapTime }}</span>
                  </span>
                </div>
              </el-form-item>
              <div class="formula_info_footer">
                <div class="formula_info_footer_item">
                  <el-form-item label="取药方式" :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugWayId`" :rules="rules.drugWayId">
                    <el-select class="formula_input_border" v-model="formula.drugWayId" placeholder="请选择处理方式" clearable :disabled="!(formula.formulaEdit&&formula.drugWayEdit)">
                      <el-option
                        v-for="(takeWay, takeWayIndex) in takeWayList"
                        :key="takeWay.drugWayId"
                        :label="`取药方式${takeWayIndex + 1}`"
                        :value="takeWay.drugWayId"
                        :disabled="takeWay.handlingTime < today">
                      </el-option>
                      <el-option label="暂不处理" value="-1" :disabled="chargeFlag && formula.status !== 0"></el-option>
                      <el-option label="无需处理" value="-2" :disabled="chargeFlag"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="formula_info_footer_item formula_info_remark">
                  <el-form-item label="备注">
                    <el-input class="formula_input_border" v-model="formula.remark" placeholder="请输入备注" :disabled="!(formula.formulaEdit&&formula.remarkEdit)"></el-input>
                  </el-form-item>
                </div>
                <div v-if="!['', '-1', '-2'].includes(formula.drugWayId)" class="formula_info_takeWay">时间：{{computedDrugWay(formula.drugWayId).handlingTime}}，医馆：{{computedDrugWay(formula.drugWayId).transferDeptName}}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 中药处方-医联产品 -->
        <template v-if="item.recipeType === 5">
          <div class="header">
            <div class="header_left">
              <span
                :class="{
                  'el-icon-success': true,
                  'header_left_icon': true,
                  'icon_success': formulaStatus(item).status
                }">
              </span>
              <div class="header_left_title">中药处方{{ item.orderNum }}-医联产品</div>
              <div class="header_left_tips">共{{ item.recipeDO.realDoseNum || item.recipeDO.doseNum }}剂</div>
              <span v-show="!formulaStatus(item).status" class="el-icon-warning header_left_error">药品内容未通过</span>
            </div>
            <div class="header_right" v-if="!chargeFlag">
              <el-button type="text" class="header_right_btn" @click="addFormula(item)">新增配方单</el-button>
            </div>
          </div>
          <div v-for="(formula, formulaIndex) in item.prescriptionPaymentVOS" :key="formula.virtuallyId" :class="{ formula: true, formula_disabled: !formula.formulaEdit }">
            <span v-show="formula.payStatus === 3" class="iconfont icon-yituif formula_refund"></span>
            <div class="formula_header">
              <div class="formula_header_left">
                <div class="formula_header_title">配方单{{ formulaIndex + 1}}</div>
                <div v-show="formula.status !== 0" class="formula_header_status" :style="`background-color: ${formulaStage(formula).bgColor};`">{{ formulaStage(formula).name }}</div>
                <div v-show="formula.drugWayId === '-1'" class="formula_header_tips">该配方单将暂不会发送，请确认后及时处理！</div>
              </div>
              <div class="formula_header_right">
                <el-button v-show="formula.status !== 0 && !formula.formulaEdit && formula.payStatus !== 3" class="formula_header_btn" @click="toFormulaEdit(formula)">修改</el-button>
                <el-popover
                  popper-class="formula_popover sf-popover"
                  placement="right-start"
                  width="230"
                  trigger="click">
                  <div class="formula_log" style="padding: 12px;box-sizing: border-box">
                    <div v-for="(log, logIndex) in formula.operateLogs" :key="logIndex" class="formula_log_item">
                      <div class="formula_log_title">{{ log.actionName }}（{{ log.deptName }}）</div>
                      <div v-if="log.operateData && log.operateData.resources && log.operateData.resources.length>0" class="list_item_right_text">
                        <el-image 
                          v-for="(item1, index) in log.operateData.resources"
                          :key="index"
                          style="width: 40px; height: 40px;margin: 6px"
                          :src="item1.resUrl" 
                          :preview-src-list="log.operateData.resources.map(item2 => item2.resUrl)"
                        ></el-image>
                      </div>
                      <div class="formula_log_text">操作员：{{ log.createBy }}</div>
                      <div class="formula_log_text">操作时间：{{ log.createTime }}</div>
                      <div v-if="log.remark" class="formula_log_text">
                        <span class="formula_log_text_label">{{ log.action === 5 ? '拒绝原因' : '修改说明' }}：</span>
                        <span class="formula_log_text_value">{{ log.remark }}</span>
                      </div>
                    </div>
                  </div>
                  <el-button slot="reference" v-show="formula.status !== 0" class="formula_header_btn">操作日志</el-button>
                </el-popover>
                <!-- <el-checkbox v-show="formula.status === 0" class="formula_header_right_freight" v-model="formula.deliveryFree" :true-label="1" :false-label="0" border>免运费</el-checkbox> -->
                <el-popconfirm
                  class="custom_popconfirm"
                  title="是否确定删除该配方单？"
                  @confirm="deleteFormula(item.prescriptionPaymentVOS, formula.virtuallyId)">
                  <el-button slot="reference" v-if="formula.status === 0 && formula.payStatus === 0 && item.prescriptionPaymentVOS.length > 1" class="formula_header_right_delete" type="text" icon="el-icon-delete"></el-button>
                </el-popconfirm>
                <el-popover
                  popper-class="formula_popover sf-popover"
                  placement="right-start"
                  width="270"
                  trigger="click"
                  @show="formula.showPopover = true"
                  @hide="formula.showPopover = copyInfo.showToolTip = false"
                >
                  <div class="transport-detail">
                    <div class="transport-detail-title">
                      <span>{{ transportInfo.logisticContext.companyName || '' }}：{{ formula.trackingNumber }}</span>
                      <el-tooltip placement="top" manual :value='copyInfo.showToolTip'>
                        <div slot="content">复制成功</div>
                        <i class="icon el-icon-copy-document" :class="{ active: copyInfo.showToolTip }" @click="copyTransportNumHandle(formula.trackingNumber)"></i>
                      </el-tooltip>
                    </div>
                    <div v-if="transportInfo.transportStepInfoList.length > 0"  class="transport-detail-content">
                      <div
                        class="transport-detail-content-item"
                        v-for="(item, index) in transportInfo.transportStepInfoList"
                        :key="index"
                      >
                        <div class="transport-detail-content-item-title">{{ item.acceptStation || '' }}</div>
                        <div class="transport-detail-content-item-time">{{ item.acceptTime || '' }}</div>
                      </div>
                    </div>
                    <div v-else class="transport-detail-content mt10 ml10">
                      暂未查询到相关物流信息
                    </div>
                  </div>
                  <el-button
                    slot="reference"
                    v-show="!!formula.trackingNumber"
                    class="formula_header_btn" 
                    @click="getTransportDetail(formula.showPopover, formula.id, formula.trackingNumber)"
                  >查看物流</el-button>
                </el-popover>
              </div>
            </div>
            <div class="formula_info">
              <el-form-item class="formula_info_item_mini" label="药品内容">
                <div class="formula_info_row">
                  <el-form-item :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].dosage`" :rules="checkNumber(formula.dosage)">
                    <el-input :ref="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].dosage`" class="formula_input" style="width: 80px;" v-model.trim="formula.dosage" oninput="if(isNaN(value)) { value = null } if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+0) } else if ( value.indexOf('.') === 0 ) { value = null }" @blur="dosageBlur(formula, `list[${index}].prescriptionPaymentVOS[${formulaIndex}]`)" :disabled="!(formula.formulaEdit&&formula.drugEdit)">
                      <span slot="suffix">剂</span>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <span v-if="formula.drugs.length > 0" class="formula_input">{{ formula.prescriptionName }}</span>
                  </el-form-item>
                  <div v-show="formula.payStatus === 2 && formula.dosageRefund > 0" class="drugs_list_default_item_return">已退{{ formula.dosageRefund }}剂</div>
                </div>
              </el-form-item>
              <el-form-item class="formula_info_item_mini" label="加工方式">
                <div class="formula_info_row">
                  <el-form-item>
                    <span class="formula_input">加工-YL</span>
                  </el-form-item>
                  <el-form-item :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].handlingAmount`" :rules="rules.handlingAmount">
                    <el-input class="formula_input formula_input_2left" style="width: 112px;" v-model="formula.pieceHandlingAmount" oninput="if(isNaN(value)) { value = null } if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+3) } else if ( value.indexOf('.') === 0 ) { value = null }" @blur="pieceHandlingAmountBlur(formula)" :disabled="!(formula.formulaEdit&&formula.processEdit) || chargeFlag">
                      <span slot="prefix">单价</span>
                      <span slot="suffix">元</span>
                    </el-input>
                    <el-input class="formula_input formula_input_2left" style="width: 112px;" v-model="formula.handlingAmount" disabled>
                      <span slot="prefix">金额</span>
                      <span slot="suffix">元</span>
                    </el-input>
                  </el-form-item>
                  <div v-if="formula.processStatus === 1" class="process_refund">已退</div>
                </div>
              </el-form-item>
              <div class="formula_info_footer">
                <div class="formula_info_footer_item">
                  <el-form-item label="取药方式" :prop="`list[${index}].prescriptionPaymentVOS[${formulaIndex}].drugWayId`" :rules="rules.drugWayId">
                    <el-select class="formula_input_border" v-model="formula.drugWayId" placeholder="请选择处理方式" clearable :disabled="!(formula.formulaEdit&&formula.drugWayEdit)">
                      <el-option
                        v-for="(takeWay, takeWayIndex) in takeWayList"
                        :key="takeWay.drugWayId"
                        :label="`取药方式${takeWayIndex + 1}`"
                        :value="takeWay.drugWayId"
                        :disabled="takeWay.handlingTime < today">
                      </el-option>
                      <el-option label="暂不处理" value="-1" :disabled="chargeFlag && formula.status !== 0"></el-option>
                      <el-option label="无需处理" value="-2" :disabled="chargeFlag"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="formula_info_footer_item formula_info_remark">
                  <el-form-item label="备注">
                    <el-input class="formula_input_border" v-model="formula.remark" placeholder="请输入备注" :disabled="!(formula.formulaEdit&&formula.remarkEdit)"></el-input>
                  </el-form-item>
                </div>
                <div v-if="!['', '-1', '-2'].includes(formula.drugWayId)" class="formula_info_takeWay">时间：{{computedDrugWay(formula.drugWayId).handlingTime}}，医馆：{{computedDrugWay(formula.drugWayId).transferDeptName}}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </el-form>
  </div>
</template>

<script>
  import { formulaDTO } from '@/DTO/index'
  import { processingPrice } from "@/api/processing";
  import SelectPanel from '@/components/SelectPanel.vue';
  import { takingDosageOptions } from '@/utils/const';
  import { copy } from '@/utils/validateBase'
  export default {
    name: 'Prescription',
    components: {
      SelectPanel
    },
    props: {
      chargeFlag: {
        type: Boolean,
        default: false
      },
      takeWayList: {
        type: Array,
        default: function() {
          return []
        }
      },
      list: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    data() {
      return {
        today: new Date().Format('yyyy-MM-dd'),
        rules: {
          handlingWay: [{ required: true, trigger: 'change' }],
          prescriptionSpecsNum: [{ required: true, trigger: 'change' }],
          handlingAmount: [{ required: true, trigger: 'blur' }],
          drugWayId: [{ required: true, trigger: 'change' }]
        },
        options: [
          {
            label: '熬药',
            value: '熬药'
          },
          {
            label: '制膏',
            value: '制膏'
          },
          {
            label: '制丸',
            value: '制丸',
            children: [
              {
                label: '蜜丸',
                value: '蜜丸'
              },
              {
                label: '水丸',
                value: '水丸'
              }
            ]
          },
          {
            label: '制粉',
            value: '制粉',
            children: [
              {
                label: '粗粉',
                value: '粗粉'
              },
              {
                label: '细粉',
                value: '细粉'
              }
            ]
          },
          {
            label: '不加工',
            value: ''
          }
        ],
        takingDosageList: takingDosageOptions,
        transportInfo: {
          logisticContext: {}, // 物流单相关信息
          transportStepInfoList: [],  // 物流跟踪信息
        },
        // 复制物流信息
        copyInfo: {
          showToolTip: false, // 是否显示复制成功提示

        }
      }
    },
    computed: {
      list2form() {
        return {
          list: this.list
        }
      },
      // 处方数量统计
      drugsCount() {
        return (formula,recipeType) => {
          let typeList = [];
          let drugSum = 0;
          formula.forEach(v => {
            v.drugs.forEach(v2 => {
              if (!typeList.includes(v2.spuId)) {
                typeList.push(v2.spuId);
                drugSum = drugSum + Number(v2.drugNum)
              }
            })
          })
          return {
            typeSum: typeList.length,
            drugSum: Math.round(drugSum * 100) / 100
          }
        }
      },
      // 药品半选计算
      drugIsIndeterminate() {
        return (drugs) => {
          let status = false;
          const allLength = drugs.filter(drug => { return drug.isOwned !== 1 }).length;
          const checkLength = drugs.filter(drug => { return drug.isOwned !== 1 && drug.checkStatus === 1 }).length;
          if (checkLength !== 0 && checkLength < allLength) {
            status = true
          }
          return status;
        }
      },
      // 药品选择统计
      drugsCheckCount() {
        return (drugs) => {
          const checkLength = drugs.filter(drug => { return drug.isOwned !== 1 && drug.checkStatus === 1 }).length;
          return checkLength
        }
      },
      // 中成药、非处方药选择统计
      otherDrugsCheckCount() {
        return (drugs) => {
          let num = 0;
          const checkList = drugs.filter(drug => { return drug.checkStatus === 1 && ![0, '0', '', null, undefined].includes(drug.useDrugNum) });
          checkList.forEach(drug => {
            num = num + Number(drug.useDrugNum);
          })
          num = Math.round(num * 100) / 100;
          return num
        }
      },
      // 处方填写状态
      formulaStatus() {
        return (prescription) => {
          let result = {
            status: true,
            type: 0, // 0: 正常;1: 剂量不平;2: 药品数量不平
            text: '',
            list: []
          }
          const doseNum = prescription.recipeDO && (prescription.recipeDO.realDoseNum || prescription.recipeDO.doseNum) || 1;
          
          let drugNormMap = {};
          let drugMap = {};
          prescription.prescriptionPaymentVOS.forEach(v1 => {
            v1.drugs.forEach(v2 => {
              if (v2.isOwned !== 1 && !Object.prototype.hasOwnProperty.call(drugNormMap, v2.spuId)) {
                drugNormMap[v2.spuId] = {
                  spuId: v2.spuId,
                  spuCommonName: v2.spuCommonName,
                  drugNum: v2.drugNum,
                  unit: v2.unit
                }
              }
              if (v2.isOwned !== 1 && v2.checkStatus === 1) {
                if (Object.prototype.hasOwnProperty.call(drugMap, v2.spuId)) {
                  drugMap[v2.spuId].dosage = drugMap[v2.spuId].dosage + Number(v1.dosage);
                  drugMap[v2.spuId].useDrugNum = Number(Math.round((drugMap[v2.spuId].useDrugNum + Number(v2.useDrugNum)) * 100) / 100);
                } else {
                  drugMap[v2.spuId] = {
                    dosage: Number(v1.dosage),
                    useDrugNum: Number(Math.round(v2.useDrugNum * 100) / 100)
                  }
                }
              }
            })
          })
          const drugNormList = Object.values(drugNormMap);
          drugNormList.forEach(v => {
            if ([1, 5].includes(prescription.recipeType)) {
              const drugDoseNum = drugMap[v.spuId] && drugMap[v.spuId].dosage || 0;
              if (drugDoseNum !== doseNum) {
                result.status = false;
                result.type = 2;
                result.list.push({
                  spuId: v.spuId,
                  spuCommonName: v.spuCommonName,
                  doseNum: drugDoseNum,
                  drugNum: v.drugNum,
                  useDrugNum: v.drugNum,
                  unit: v.unit,
                  text: drugDoseNum > doseNum ? '已超出总量' : '未全部分配'
                })
              }
            } else {
              const useDrugNum = drugMap[v.spuId] && drugMap[v.spuId].useDrugNum || 0;
              if (useDrugNum !== v.drugNum) {
                result.status = false;
                result.type = 2;
                result.list.push({
                  spuId: v.spuId,
                  spuCommonName: v.spuCommonName,
                  doseNum: 1,
                  drugNum: v.drugNum,
                  useDrugNum: useDrugNum,
                  unit: v.unit,
                  text: useDrugNum > v.drugNum ? '已超出总量' : '未全部分配'
                })
              }
            }
          })

          if ([1, 5].includes(prescription.recipeType) && !result.status) {
            const drugNumList = prescription.prescriptionPaymentVOS[0].drugs.filter(v => { return v.isOwned !== 1 });
            const doseNumList = result.list.map(v => v.doseNum);
            const diffList = Array.from(new Set(doseNumList));
            if (doseNumList.length === drugNumList.length && diffList.length === 1) {
              const diff = diffList[0] - doseNum;
              result.type = 1;
              result.text = diff > 0 ? `多分配了${Math.abs(diff)}剂处方` : `还有${Math.abs(diff)}剂处方未分配`
            }
          }

          return result
        }
      },
      // 配方单阶段状态
      formulaStage() {
        return (formula) => {
          let name = ''
          let bgColor = ''

          const drugWay = this.takeWayList.find(v => { return v.drugWayId === formula.drugWayId })

          const statusList = {
            0: { name: '待发送', bgColor: '' },
            1: { name: '待收方', bgColor: '#1890FF' },
            2: { name: '待配方', bgColor: '#FE8F1F' },
            3: { name: '配方中', bgColor: '#FE8F1F' },
            4: { name: '待复核', bgColor: '#FE8F1F' },
            5: { name: '待加工', bgColor: '#FE8F1F' },
            6: { name: '加工中', bgColor: '#FE8F1F' },
            7: { name: '待打包', bgColor: '#FE8F1F' },
            8: { name: '待配送', bgColor: '#29C01B' },
            9: { name: '配送中', bgColor: '#29C01B' },
            10: { name: '待提货', bgColor: '#29C01B' },
            11: { name: '已完成', bgColor: '#29C01B' },
            12: { name: '已退费', bgColor: '#F54A45' }
          }

          const childStatusList = [
            { value: 600101, label: '待泡药' },
            { value: 600102, label: '待熬药' },
            { value: 600103, label: '待装袋' },

            { value: 600201, label: '待泡药' },
            { value: 600202, label: '待熬药' },
            { value: 600203, label: '待浓缩' },
            { value: 600204, label: '待收膏' },
            { value: 600205, label: '待晾膏' },

            { value: 600301, label: '待打粉' },
            { value: 600302, label: '待熬药' },
            { value: 600303, label: '待制丸' },
            { value: 600304, label: '待烘干' },
            { value: 600305, label: '待分装' },

            { value: 600401, label: '待打粗粉' },
            { value: 600402, label: '待打细粉' },

            { value: 600501, label: '待加工' },
            { value: 600502, label: '加工中' }
          ]

          if ([5, 6].includes(formula.status)) {
            const node = childStatusList.find(item => { return item.value == formula.childStatus })
            if (node) {
              name = node.label
            }
          } else if ([9].includes(formula.status)) {
            if (drugWay.deliveryWay === 0 && drugWay.transferDeptId === 127) {
              name = '送回中'
            } else {
              name = '配送中'
            }
          } else if ([10].includes(formula.status)) {
            if (drugWay.deliveryWay === 0 || (drugWay.deliveryWay === 1 && drugWay.status === 1)) {
              name = '待自提'
            } else {
              name = '待收货'
            }
          } else {
            name = statusList[formula.status].name
          }

          bgColor = statusList[formula.status].bgColor

          return {
            name: name,
            bgColor: bgColor
          }
        }
      },
      // 计算取药方式信息
      computedDrugWay() {
        return (drugWayId) => {
          const drugWay = this.takeWayList.find(v => { return v.drugWayId === drugWayId });
          return {
            handlingTime: drugWay && drugWay.handlingTime && new Date(drugWay.handlingTime).Format('yyyy-MM-dd') || '',
            transferDeptName: drugWay && drugWay.transferDeptName || ''
          }
        }
      }
    },
    methods: {
      // 编辑状态切换
      toFormulaEdit(formula) {
        this.$confirm('该配方单已经开始处理，修改后可能会产生损失，请谨慎修改！', '提示', {
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          formula.formulaEdit = true;
          const takeWay = this.takeWayList.find(v => { return v.drugWayId === formula.drugWayId });
          if (takeWay) {
            takeWay['takeWayEdit'] = true;
          }
        }).catch(() => {})
      },
      // 输入非0数字校验
      checkNumber(num) {
        return [{
          validator: (rule, value, callback) => {
            if ([0, '0', '', null, undefined].includes(num)) {
              callback(new Error())
            } else {
              callback()
            }
          },
          trigger: 'change'
        }]
      },
      // 选择药品校验
      checkDrugsSelect(drugs) {
        return [{
          validator: (rule, value, callback) => {
            const checkLength = drugs.filter(drug => { return drug.isOwned !== 1 && drug.checkStatus === 1 }).length;
            if ([0, '0', '', null, undefined].includes(checkLength)) {
              callback(new Error())
            } else {
              callback()
            }
          },
          trigger: 'change'
        }]
      },
      // 选择药品校验
      checkOtherDrugsSelect(drugs) {
        return [{
          validator: (rule, value, callback) => {
            const checkLength = drugs.filter(drug => { return drug.checkStatus === 1 && ![0, '0', '', null, undefined].includes(drug.useDrugNum) }).length;
            let drugCheckStatus = true;
            drugLoop: for (let i = 0; i < drugs.length; i++) {
              if (drugs[i].checkStatus === 1 && [0, '0', '', null, undefined].includes(drugs[i].useDrugNum)) {
                drugCheckStatus = false;
                break drugLoop;
              }
            }
            if ([0, '0', '', null, undefined].includes(checkLength) || !drugCheckStatus) {
              callback(new Error())
            } else {
              callback()
            }
          },
          trigger: 'change'
        }]
      },
      // 中成药品、非处方药品数量校验
      checkOtherDrugsNum(drug) {
        return [{
          validator: (rule, value, callback) => {
            if (drug.checkStatus === 1 && [0, '0', '', null, undefined].includes(drug.useDrugNum)) {
              callback(new Error())
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      },
      // 表单校验
      validate() {
        return this.$refs['prescription_form'].validate().catch(() => false);
      },
      // 获取加工费用
      getProcessingPrice(row) {
        if (this.chargeFlag) {
          return false;
        }
        if (row.handlingWay[row.handlingWay.length - 1] === '加工-YL') {
          const price = Math.round(Number(row.pieceHandlingAmount) * Number(row.dosage) * 100) / 100;
          row.handlingAmount = price;
        } else {
          let weight = 0;
          row.drugs.forEach(v => {
            if (v.isOwned !== 1 && v.checkStatus === 1 && v.unit === 'g') {
              weight = weight + Number(v.drugNum)
            }
          });
          weight = weight * Number(row.dosage);
          weight = Math.round(weight * 100) / 100;
          let params = {
            number: row.dosage,
            processingType: row.handlingWay[row.handlingWay.length - 1],
            weight: weight,
            bagNumberSum: row.prescriptionTotalNum
          }
          if (row.handlingWay[row.handlingWay.length - 1] !== '熬药') {
            params.bagNumber = '0'
          };
          if (!row.dosage || row.handlingWay[row.handlingWay.length - 1] === '' || (row.handlingWay[row.handlingWay.length - 1] === '熬药' && [0, '0', '', null].includes(row.prescriptionTotalNum))) {
            row.handlingAmount = 0
          } else {
            this.$emit('loadingChange', true);
            processingPrice(params).then(res => {
              this.$emit('loadingChange', false);
              if (res.code == 200) {
                row.handlingAmount = res.data
              }
            })
          }
        }
      },
      // 药品全选
      drugsCheckAll(formula) {
        if (formula.checkAll) {
          formula.drugs.map(v => {
            if (v.isOwned !== 1) {
              v.checkStatus = 1
            }
          })
        } else {
          formula.drugs.map(v => {
            if (v.isOwned !== 1) {
              v.checkStatus = 0
            }
          })
        }
        this.getProcessingPrice(formula);
      },
      // 药品单选
      drugsCheck(formula, drug, key) {
        if (key) {
          if (drug.checkStatus === 1) {
            this.$refs['prescription_form'].validateField(key)
          } else {
            this.$refs['prescription_form'].clearValidate(key)
          }
        }
        const allLength = formula.drugs.filter(drug => { return drug.isOwned !== 1 }).length;
        const checkLength = formula.drugs.filter(drug => { return drug.isOwned !== 1 && drug.checkStatus === 1 }).length;
        if (checkLength === allLength) {
          formula.checkAll = true
        }
        if (checkLength === 0) {
          formula.checkAll = false
        }
        this.getProcessingPrice(formula);
      },
      // 加工方式切换
      handlingWayChange(row, recipe) {
        if (row.handlingWay[0] === '熬药') {
          row.prescriptionNum = '';
          row.prescriptionTotalNum = '';
          row.prescriptionSpecsNum = recipe.takingDosage;
        } else {
          row.prescriptionNum = '';
          row.prescriptionTotalNum = '';
          row.prescriptionSpecsNum = ''
        }
        this.getProcessingPrice(row);
      },
      // 剂失焦
      dosageBlur(row, key) {
        if (![null, undefined, '', '0', 0].includes(row.dosage)) {
          row.dosage = Number(row.dosage)
        } else {
          row.dosage = 1
        }
        row.prescriptionTotalNum = Math.ceil(Number(row.prescriptionNum) * Number(row.dosage));
        this.$refs['prescription_form'].validateField([`${key}[prescriptionNum]`, `${key}[prescriptionTotalNum]`, `${key}[handlingAmount]`]);
        if (row.processEdit) {
          this.getProcessingPrice(row);
        }
      },
      // 每剂袋失焦
      prescriptionNumBlur(row, key) {
        if (row.prescriptionNum) {
          row.prescriptionNum = Number(row.prescriptionNum)
        }
        row.prescriptionTotalNum = Math.ceil(Number(row.prescriptionNum) * Number(row.dosage));
        this.$refs['prescription_form'].validateField([`${key}[prescriptionTotalNum]`, `${key}[handlingAmount]`]);
        this.getProcessingPrice(row);
      },
      // 共袋失焦
      prescriptionTotalNumBlur(row, key) {
        if (row.prescriptionTotalNum) {
          row.prescriptionTotalNum = Number(row.prescriptionTotalNum)
        }
        row.prescriptionNum = Math.round((Number(row.prescriptionTotalNum) / Number(row.dosage)) * 10) / 10;
        if (row.prescriptionNum === Infinity || row.prescriptionNum === -Infinity) {
          row.prescriptionNum = 0
        }
        this.$refs['prescription_form'].validateField([`${key}.prescriptionNum`, `${key}[handlingAmount]`]);
        this.$forceUpdate();
        this.getProcessingPrice(row);
      },
      // 单价失焦
      pieceHandlingAmountBlur(row) {
        if (!['', null, undefined].includes(row.pieceHandlingAmount)) {
          row.pieceHandlingAmount = Number(row.pieceHandlingAmount)
          this.getProcessingPrice(row)
        }
      },
      // 金额失焦
      handlingAmountBlur(row) {
        if (!['', null, undefined].includes(row.handlingAmount)) {
          row.handlingAmount = Number(row.handlingAmount)
        }
      },
      // 药品数量失焦
      drugNumBlur(drug) {
        if (![null, undefined, ''].includes(drug.useDrugNum)) {
          drug.useDrugNum = Number(drug.useDrugNum);
          if (drug.useDrugNum > Number(drug.drugNum)) {
            drug.useDrugNum =  Number(drug.drugNum)
          }
        }
      },
      // 新增配方单
      addFormula(prescription) {
        let formula = JSON.parse(JSON.stringify(prescription.prescriptionPaymentVOS[0]));
        formula.id = null;
        formula.virtuallyId = new Date().getTime();
        if ([1, 5].includes(prescription.recipeType)) {
          formula.dosage = '';
        } else if (prescription.recipeType === 4) {
          formula.dosage = '';
          formula.checkAll = false;
          formula.drugs.map(v => {
            v.checkStatus = 0
          })
        }
        formula.trackingNumber = '';
        formula.status = 0;
        formula.payStatus = 0;
        formula.processStatus = 0;
        formula.formulaEdit = true;
        formula.drugEdit = true;
        formula.processEdit = true;
        formula.drugWayEdit = true;
        formula.remarkEdit = true;
        formula.operateLogs = [];
        formula.drugWayId = '';
        formula.drugs.map(v => {
          v.status = 0;
          v.drugNumRefund = 0;
        });
        if (this.chargeFlag) {
          formula.pieceHandlingAmount = 0;
          formula.handlingAmount = 0;
        }
        prescription.prescriptionPaymentVOS.push(formula);
      },
      // 删除配方单
      deleteFormula(list, virtuallyId) {
        const delIndex = list.findIndex(v => { return v.virtuallyId === virtuallyId });
        list.splice(delIndex, 1);
      },

      // 获取物流跟踪信息详情
      async getTransportDetail(currentPopoverIsShow, prescriptionId = '', logisticCode = '') {
        // 如果当前配方单的物流信息popover是打开的，则不请求
        if (currentPopoverIsShow) return

        this.transportInfo.logisticContext = {}
        this.transportInfo.transportStepInfoList = []
        const params = {
          prescriptionId,
          logisticCode
        }
        const res = await formulaDTO.getTransPortStepDetail(params)
        if (res.code === 200) {
          this.transportInfo.logisticContext = res.data.logisticContext || {}
          if (res.data.success === 1) {
            this.transportInfo.transportStepInfoList = res.data.traces || []
          }
        }
      },

      // 复制物流单号
      copyTransportNumHandle(transportNum = '') {
        copy(transportNum, true)
        this.copyInfo.showToolTip = true
        setTimeout(() => {
          this.copyInfo.showToolTip = false
        }, 2000)
      }
    }
  }
</script>

<style lang="less" scoped>
  .prescription{
    width: 100%;
  }

  .item{
    margin: 16px 0 0 0;
    width: 100%;
  }

  .prescription .item:first-child{
    margin: 0 0 0 0;
  }

  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_left_icon{
    font-size: 18px;
    color: #DBDBDB;
  }

  .header_left_icon.icon_success{
    color: #29C01B;
  }

  .header_left_title{
    margin: 0 0 0 4px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .header_left_tips{
    margin: 0 0 0 6px;
    font-size: 14px;
    color: #667182;
  }

  .header_left_error{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 10px;
    font-size: 14px;
    color: #F54A45;
    cursor: default;
  }

  .header_left_error::before{
    margin: 0 4px 0 0;
  }

  .header_error_row{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    width: 432px;
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .header_error_item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 210px;
  }

  .header_error_row .header_error_item:nth-child(2n) {
    margin: 0 0 0 12px;
  }

  .header_error_item_left{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .header_error_item_left_name{
    max-width: 70px;
    font-size: 14px;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .header_error_item_left_num{
    margin: 0 0 0 4px;
    font-size: 14px;
    color: #667182;
  }

  .header_error_item_right{
    font-size: 14px;
    color: #F54A45;
  }

  .header_error_lineText{
    font-size: 14px;
    color: #000000;
  }

  .header_right{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_right_btn{
    padding: 0;
    font-size: 14px;
    color: #1890FF;
  }

  .formula{
    position: relative;
    z-index: 1;
    margin: 12px 0 0 0;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
  }

  .formula.formula_disabled{
    background-color: transparent;
  }

  .formula.formula_disabled /deep/ .el-input__inner{
    background-color: transparent;
  }

  .formula_refund{
    position: absolute;
    z-index: 2;
    left: 160px;
    top: -8px;
    font-size: 58px;
    color: #F54A45;
  }

  .formula_header{
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #E0E0E0;
  }

  .formula_header_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .formula_header_title{
    font-size: 14px;
    color: #000000;
  }

  .formula_header_status{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 18px;
    width: 58px;
    height: 20px;
    font-size: 14px;
    color: #FFFFFF;
    border-radius: 20px;
  }

  .formula_header_tips{
    margin: 0 0 0 18px;
    font-size: 14px;
    color: #FE8F1F;
  }

  .formula_header_right{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .formula_log{
    width: 100%;
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .formula_log_item{
    width: 100%;
    overflow: hidden;
  }

  .formula_log .formula_log_item:not(:first-child) {
    margin: 8px 0 0 0;
  }

  .formula_log_title{
    line-height: 14px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .formula_log_text{
    margin: 3px 0 0 0;
    line-height: 16px;
    font-size: 12px;
    color: #667182;
  }

  .formula_log_text_label{
    white-space: nowrap;
  }

  .formula_log_text_value{
    word-wrap: break-word;
    word-break: break-all;
    text-align: left;
  }

  .formula_header_btn{
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 6px;
    padding: 0 6px;
    height: 24px;
    font-size: 14px;
    color: #667182;
    border: 1px solid #D3D3D5;
  }

  .formula_header_right_freight{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 6px;
    height: 28px;
  }

  .formula_header_right_delete{
    margin: 0 0 0 10px;
    padding: 4px;
    font-size: 16px;
    color: #667182;
  }

  .formula_header_right_delete:hover{
    color: #F54A45;
  }

  .formula_info{
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
  }

  /deep/.formula_info .el-form-item__label{
    color: #667182;
  }

  /deep/.formula_info_item_mini .el-form-item__label, /deep/.formula_info_item_mini .el-form-item__content{
    line-height: 24px;
  }

  /deep/.formula_info .el-form-item{
    margin: 0 0 0 0;
  }

  /deep/.formula_info>.el-form-item{
    margin: 8px 0 0 0;
  }

  /deep/.formula_info>.el-form-item:first-child{
    margin: 0 0 0 0;
  }

  .formula_info_row{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .formula_input{
    margin: 0 8px 0 0;
  }

  /deep/.formula_input .el-input__inner{
    height: 24px;
    line-height: 24px;
    text-align: center;
    border: none;
    border-bottom: 1px solid #D3D3D5;
  }

  /deep/.formula_input_2left .el-input__inner{
    padding-left: 40px;
  }

  .formula_drugs{
    width: 100%;
  }

  .drugs_header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 36px;
    border-bottom: 1px solid #E0E0E0;
  }

  .drugs_header_title{
    font-size: 14px;
    color: #667182;
  }

  .drugs_list_default{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    overflow: hidden;
  }

  .drugs_list_default_item{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 12px 6px 0 0;
  }

  .drugs_list_default_item /deep/ .el-checkbox__label{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 8px;
    padding: 0;
    width: 115px;
  }

  .drugs_list_default_item_label{
    width: 85px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .drugs_list_default_item_return{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px;
    line-height: 12px;
    font-size: 12px;
    color: #F54A45;
    border: 1px solid #F54A45;
    border-radius: 2px;
  }

  .drugs_list_other{
    width: 100%;
    overflow: hidden;
  }

  .drugs_list_other_item{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }

  .drugs_list_other_checkbox{
    flex-shrink: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .drugs_list_other_checkbox /deep/ .el-checkbox__label{
    margin: 0 0 0 8px;
    padding: 0;
    width: 110px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .drugs_other_info{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .drugs_other_info /deep/ .el-form-item{
    margin: 0 0 0 0;
  }

  .drugs_other_info /deep/ .el-form-item__content {
    line-height: 24px;
  }

  .drugs_other_info_icon{
    font-size: 14px;
    color: #667182;
  }

  .drugs_other_info_text{
    font-size: 14px;
    color: #667182;
  }

  .drugs_other_info_return{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 4px;
    padding: 0 2px;
    font-size: 12px;
    color: #F54A45;
    border: 1px solid #F54A45;
    border-radius: 2px;
  }

  .drugs_other_info .formula_input{
    margin: 0 8px;
    line-height: 24px;
  }

  .drugs_other_info .formula_input /deep/ .el-input__inner{
    padding: 0 30px 0 0;
    text-align: right;
    background-color: #FFFDE9;
  }

  .drugs_other_info .formula_input /deep/ .el-input__suffix .el-icon-circle-close{
    display: none;
  }

  .formula_cascader{
    line-height: 24px;
  }

  /deep/.formula_cascader .el-input__inner{
    padding: 0 0 0 0;
  }

  /deep/.formula_cascader .el-input__suffix{
    display: none;
  }

  /deep/.is-error .formula_input .el-input__inner{
    background-color: #FFF0E1;
    border-color: #FE8F1F;
  }

  .formula_input.SelectPanel{
    height: 24px;
  }

  .process_refund{
    box-sizing: border-box;
    padding: 0 2px;
    height: 18px;
    line-height: 14px;
    font-size: 12px;
    color: #F54A45;
    border: 1px solid #F54A45;
    border-radius: 2px;
  }

  .prescription_usage{
    margin: 6px 0 0 0;
    font-size: 12px;
    color: #667182;
  }

  .formula_info_footer{
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: 8px 0 0 0;
    width: 100%;
  }

  .formula_info_footer_item{
    box-sizing: border-box;
    flex-grow: 1;
    flex-shrink: 0;
    width: calc( (100% - 12px) / 2 );
  }

  .formula_info_footer_item:not(:first-child) {
    margin: 0 0 0 12px;
  }

  .formula_info_footer_item /deep/ .el-form-item__label,.formula_info_footer_item /deep/ .el-form-item__content{
    line-height: 32px;
    color: #667182;
  }

  .formula_info_takeWay{
    margin: 6px 0 0 70px;
    line-height: 24px;
    font-size: 14px;
    color: #29C01B;
  }

  .formula_input_border{
    width: 100%;
  }

  /deep/ .is-error .formula_input_border .el-input__inner {
    border-color: #FE8F1F;
  }

  /deep/.formula_info_remark .el-form-item__label{
    text-align: justify;
    text-align-last: justify;
  }

  /*
     配方单物流信息样式
  */ 
  .transport-detail {
    position: relative;
    padding: 0 12px 12px;
    box-sizing: border-box;
    width: 100%;
    height: 300px;
    font-size: 14px;
    overflow-y: auto;
  }

  .transport-detail-title {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 2;
    padding: 12px 0 4px;
    color: #000000;
    background: #FFFDE9;
  }

  .transport-detail-title .icon {
    margin-left: 10px;
    color: #8892A3;
    cursor: pointer;
    transform: rotate(180deg);

    &:hover,&.active {
      color: #1890FF;
    }
  }

  // 物流step
  .transport-detail-content {
    color: #8892A3;
  }

  .transport-detail-content-item {
    position: relative;
    padding: 6px 0 0 20px;
    &:nth-child(1) {
      color: #1890FF;
      &:before {
        background-color: #1890FF;
      }
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 10px;
      z-index: 1;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #CCD4DC;
    }
    &:after {
      content: '';
      position: absolute;
      left: 4px;
      top: 10px;
      z-index: 0;
      width: 2px;
      height: 100%;
      background-color: #CCD4DC;
    }
  }

  .transport-detail-content-item-time {
    margin-top: 2px;
    font-size: 12px;
  }

</style>

<style>
  .el-popover.formula_popover.sf-popover {
    padding: 0!important;
  }
</style>
